<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('setting.bank_info')" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>

      <div class="bank-card-display" v-else>
        <div class="card-bg">
          <div class="card-top">
            <van-icon name="card" class="card-icon" />
            <span class="bank-name">{{this.bankInfo.bankinfo}}</span>
          </div>
          <div class="card-middle">
            <span class="card-number">{{ formatBankId(this.bankInfo.bankid) }}</span>
          </div>
          <div class="card-bottom">
            <div class="card-user">
              <span class="label">Cardholder</span>
              <span class="value">{{this.userInfo.name}}</span>
            </div>
            <van-icon name="checked" class="bind-success-icon" />
          </div>
        </div>
      </div>

      <!-- 银行卡绑定提示：紧跟银行卡区域下方 -->
      <div class="tips bind-tip">
        <van-icon name="info-o" />
        {{$t("setting.bind_bank_tip")}}
      </div>

      <!-- 收款二维码：可上传/修改，支持快捷支付提款 -->
      <div class="qrcode-section">
        <div class="section-title">
          <van-icon name="qr" />
          {{$t("setting.qrcode_title")}}
        </div>
        <div class="qrcode-box" v-if="userInfo.qrcode_img" @click="pickQrcode()">
          <img :src="userInfo.qrcode_img" class="qrcode-img" />
          <div class="qrcode-mask">{{$t("setting.qrcode_change")}}</div>
        </div>
        <div class="qrcode-empty" v-else @click="pickQrcode()">
          <van-icon name="plus" />
          <span>{{$t("setting.qrcode_upload")}}</span>
        </div>
        <input type="file" ref="qrfile" accept="image/png,image/jpeg" style="display:none" @change="onQrcodeFile" />
      </div>

      <div class="tips">
        <van-icon name="info-o" />
        {{$t("setting.qrcode_tip")}}
      </div>

      <!-- PayPay 绑定：提款ID/手机号码手动输入可编辑，任意一项即可申请提款 -->
      <div class="paypay-section">
        <div class="section-title">
          <van-icon name="balance-pay" />
          {{$t("setting.paypay_title")}}
        </div>
        <div class="paypay-form">
          <div class="paypay-field">
            <span class="paypay-label">{{$t("setting.paypay_id")}}</span>
            <input type="text" v-model="paypay_id" maxlength="64" :placeholder="$t('setting.paypay_id_ph')" />
          </div>
          <div class="paypay-field">
            <span class="paypay-label">{{$t("setting.paypay_phone")}}</span>
            <input type="text" v-model="paypay_phone" maxlength="32" :placeholder="$t('setting.paypay_phone_ph')" />
          </div>
          <button class="paypay-save" @click="savePaypay()">{{$t("setting.paypay_save")}}</button>
        </div>
      </div>

      <div class="tips">
        <van-icon name="info-o" />
        {{$t("setting.paypay_tip")}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{},
      qr_uploading:false,
      paypay_id:'',
      paypay_phone:'',
      paypay_saving:false
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    formatBankId(id) {
      if (!id) return '';
      // 每4位加一个空格
      return id.replace(/(.{4})/g, '$1 ').trim();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
          // 回显已绑定的 PayPay 提款ID/手机号码，可手动修改后重新提交
          this.paypay_id = res.data.paypay_id || '';
          this.paypay_phone = res.data.paypay_phone || '';
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      // 移除未填写名称就跳转的限制
      this.$router.push({path:'/BindCard'});
      return true;
    },
    pickQrcode() {
      this.$refs.qrfile.click();
    },
    // 选择收款码图片：前端压缩到 800px 以内再上传，避免请求体超限
    onQrcodeFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      if (!/image\/(png|jpe?g)/.test(file.type)) {
        this.$toast(this.$t('setting.qrcode_type_error'));
        return;
      }
      const reader = new FileReader();
      reader.onload = (ev) => {
        const img = new Image();
        img.onload = () => {
          const max = 800;
          let w = img.width, h = img.height;
          if (w > max || h > max) {
            const scale = max / Math.max(w, h);
            w = Math.round(w * scale);
            h = Math.round(h * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          this.uploadQrcode(canvas.toDataURL('image/jpeg', 0.85));
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadQrcode(dataUrl) {
      if (this.qr_uploading) return;
      this.qr_uploading = true;
      this.$toast.loading({ duration: 0, forbidClick: true });
      this.$http({
        method: 'post',
        data: { qrcode: dataUrl },
        url: 'user_qrcode'
      }).then(res => {
        this.$toast.clear();
        this.qr_uploading = false;
        if (res && res.code === 200) {
          this.$set(this.userInfo, 'qrcode_img', (res.data && res.data.qrcode_img) || dataUrl);
          this.$toast(this.$t('setting.qrcode_success'));
        } else {
          this.$toast((res && res.msg) || this.$t('setting.qrcode_fail'));
        }
      });
    },
    // 提交 PayPay 绑定：ID/手机号码任意一项非空即可，与二维码互不冲突
    savePaypay() {
      const id = (this.paypay_id || '').trim();
      const phone = (this.paypay_phone || '').trim();
      if (!id && !phone) {
        this.$toast(this.$t('setting.paypay_empty'));
        return;
      }
      if (this.paypay_saving) return;
      this.paypay_saving = true;
      this.$toast.loading({ duration: 0, forbidClick: true });
      this.$http({
        method: 'post',
        data: { paypay_id: id, paypay_phone: phone },
        url: 'user_paypay'
      }).then(res => {
        this.$toast.clear();
        this.paypay_saving = false;
        if (res && res.code === 200) {
          this.paypay_id = id;
          this.paypay_phone = phone;
          this.$set(this.userInfo, 'paypay_id', id);
          this.$set(this.userInfo, 'paypay_phone', phone);
          this.$toast(this.$t('setting.paypay_success'));
        } else {
          this.$toast((res && res.msg) || this.$t('setting.paypay_fail'));
        }
      });
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.setbank-page {
  background-color: #1f1c1f;
  min-height: 100vh;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #2b2b2b !important;
  border-bottom: 2px solid #766350;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.wrapper {
  padding: 40px 30px;
}

.add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e6b98a;
  background-color: #2b2b2b;
  border: 2px dashed #766350;
  border-radius: 20px;
  height: 200px;
  font-size: 32px;
  cursor: pointer;
  
  span {
    margin-left: 16px;
  }
}

.bank-card-display {
  width: 100%;
  perspective: 1000px;
}

.card-bg {
  background: linear-gradient(135deg, #d4a572, #a67c52);
  border-radius: 24px;
  padding: 40px;
  color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }
}

.card-top {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  
  .card-icon {
    font-size: 48px;
    margin-right: 20px;
    color: rgba(255, 255, 255, 0.9);
  }
  
  .bank-name {
    font-size: 36px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
  }
}

.card-middle {
  margin-bottom: 40px;
  
  .card-number {
    font-family: 'Courier New', Courier, monospace;
    font-size: 46px;
    letter-spacing: 4px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.4);
  }
}

.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  
  .card-user {
    display: flex;
    flex-direction: column;
    
    .label {
      font-size: 24px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 8px;
      text-transform: uppercase;
    }
    
    .value {
      font-size: 32px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  
  .bind-success-icon {
    font-size: 50px;
    color: rgba(255, 255, 255, 0.8);
  }
}

.tips {
  margin-top: 40px;
  font-size: 26px;
  color: #999;
  line-height: 1.5;
  letter-spacing: 1px;
  display: flex;
  align-items: flex-start;
  background: #242424;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #333;
  
  .van-icon {
    margin-right: 12px;
    margin-top: 4px;
    color: #e6b98a;
    font-size: 32px;
  }
}

/* 银行卡提示：紧跟银行卡区域，间距收紧与页面整体协调 */
.bind-tip {
  margin-top: 24px;
}

/* 收款二维码区块 */
.qrcode-section {
  margin-top: 40px;
}

.section-title {
  display: flex;
  align-items: center;
  color: #e6b98a;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 24px;

  .van-icon {
    margin-right: 12px;
    font-size: 36px;
  }
}

.qrcode-box {
  position: relative;
  width: 360px;
  margin: 0 auto;
  cursor: pointer;

  .qrcode-img {
    width: 100%;
    border-radius: 16px;
    border: 2px solid #766350;
    display: block;
  }

  .qrcode-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 64px;
    line-height: 64px;
    text-align: center;
    color: #fff;
    font-size: 28px;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 0 0 16px 16px;
  }
}

.qrcode-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #e6b98a;
  background-color: #2b2b2b;
  border: 2px dashed #766350;
  border-radius: 20px;
  height: 240px;
  font-size: 30px;
  cursor: pointer;

  .van-icon {
    font-size: 48px;
    margin-bottom: 16px;
  }
}

/* PayPay 绑定区块 */
.paypay-section {
  margin-top: 40px;
}

.paypay-form {
  background-color: #2b2b2b;
  border: 2px solid #766350;
  border-radius: 20px;
  padding: 30px 24px;
}

.paypay-field {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #3a3a3a;
  padding-bottom: 16px;
  margin-bottom: 24px;

  &:focus-within {
    border-bottom-color: #e6b98a;
  }

  .paypay-label {
    width: 160px;
    flex-shrink: 0;
    color: #e6b98a;
    font-size: 28px;
  }

  input {
    flex: 1;
    min-width: 0;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 30px;

    &::placeholder {
      color: #555;
      font-size: 26px;
    }
  }
}

.paypay-save {
  width: 100%;
  height: 88px;
  margin-top: 8px;
  background: linear-gradient(to right, #efcba7, #dcab76);
  border: none;
  border-radius: 16px;
  color: #68302c;
  font-size: 32px;
  font-weight: bold;
  cursor: pointer;

  &:active {
    opacity: 0.9;
    transform: translateY(2px);
  }
}
</style>
